// @ts-check
import { required } from '@vuelidate/validators';

export class ApplicationModel {
  constructor({ Id, Description, GroupId, OrganizationId, ScopeId, RoleId }) {
    this._modelName = 'Application';
    this.saved = false; // We have no auto-generated from backend ID to check...
    this.Id = Id || null;
    this.Description = Description || null;
    this.GroupId = GroupId;
    this.OrganizationId = OrganizationId;
    this.ScopeId = ScopeId;
    this.RoleId = RoleId;
  }

  __copy() {
    return JSON.parse(JSON.stringify(this));
  }

  static get validations() {
    return {
      Id: {
        required
      },
      Description: {
        required
      },
      ScopeId: {
        required
      },
      RoleId: {
        required
      }
    };
  }
}

export default ApplicationModel;
